import { render, staticRenderFns } from "./NodataComponent.vue?vue&type=template&id=8b14a192"
import script from "./NodataComponent.vue?vue&type=script&lang=js"
export * from "./NodataComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports